<template>
  <div class="order-grid col-sm-12 col-md-12 col-lg-12">
    <div class="header2">
      <h1 class="title">Current Medications</h1>
      <button type="button" @click="showAddMed">
        <font-awesome-icon icon="plus-circle" />
      </button> <h1>|</h1> 
      <h1 class="title">
        <router-link to="/medAdministration">
          Medication Administration
        </router-link>
      </h1>
    </div>
    <div class="mediationmodal col-sm-12 col-md-12 col-lg-12" :id="'mediationmodal' + patient.id">
      <div class="modaltop">
        <section class="patienttopinfosec col-sm-12 col-md-6 col-lg-6">
          <div id="patientname">
            <p id="pname">{{ patient.firstName + " " + patient.lastName }}</p>
          </div>
          <div class="allergysec">
            <span class="allergytext">Allergies: 
              <span >{{ allergies.toString() + ',' + manualAllergies.toString() }}</span>
            </span><br />
            <p></p>
          </div>
        </section>
        <section class="patientsecondinfosec col-sm-12 col-md-6 col-lg-6">
          <div id="patientbday">
            <p id="pday">{{ patient.dob }}</p>
          </div>
          <div class="attendphysician">
            <!-- <span>Attending Physician</span><br /> -->
            <!-- <p>Dr. Joseph Mulvehill</p> -->
          </div>
        </section>
      </div>
      <form :id="'dosesform' + patient.id" @submit.prevent="saveMed">
        <div class="mednamesec col-sm-12 col-lg-12">
          <input required name="medsearchbox" class="medsearchbox" type="search" :id="'medsearchbox' + patient.id"
            placeholder="Search for Medications" v-model="medicationSearchDescrip" @keyup.prevent="showMedSearch" />
          <div v-if="searchedMeds" :class="'searchresult' + patient.id" id="medsearchresult">
            <div v-for="med in searchedMeds" class="medlist" :key="med.rxcui" @click="clickMed(med)">
              <span id="rxcui">{{ med.rxcui }}</span>
              <p>{{ med.name }}</p>
            </div>
          </div>
        </div>
        <div class="modalbottom">
          <!-- <form :id="'dosesform'+patient.id" @submit.prevent="saveMed"> -->
          <!-- <form :id="'medsearchform'+patient.id">
                    <input
                      type="search"
                      :id="'medsearchbox'+patient.id"
                      placeholder="Search for Medications"
                      v-model="medicationSearchDescrip"
                      @keyup.prevent="showMedSearch"
                    />
                    <div v-if="searchedMeds" :class="'searchresult'+patient.id" id="medsearchresult">
                      <div v-for="med in searchedMeds" class="medlist" :key="med.rxcui" @click="clickMed(med)">
                        <span id="rxcui">{{med.rxcui}}</span>
                        <p>{{med.name}}</p>
                      </div>
                    </div>
                    <div class="srchbtncontainer">
                      <input type="button" value="Cancel" :id="'cancelbtn'+patient.id" @click="closeFirstMed"/>
                    </div>
                  </form> -->
          <div class="medfirstSec col-sm-12 col-md-4 col-lg-4">
            <!-- <div class="flex-row">
                        <input
                          name="dosage"
                          type="text"
                          placeholder="Ex 2.5 or 1-2.5"
                          id="doseamount"
                        />  
                        <select id="doesUOM" name="UOM" required>
                          <option selected="selected" value="Dose UOM"
                            >DOSE UOM *</option
                          >
                          <option value="mg">mg</option>
                          <option value="tablet">tablet</option>
                          <option value="per instruction"
                            >per instruction</option
                          >
                        </select>
                      </div> -->
            <div class="flex-row">
              <select id="freqselect" name="freq" required>
                <option selected="selected" value="Frequency">Frequency *</option>
                <option v-for="time in mT" :key="time + patient.id" :value="time">
                  {{ time }}
                </option>
              </select>
              <label class="prn-label">PRN<input name="PRN" type="checkbox" :id="'prncheckbox' + patient.id"
                  value="PRN" />
              </label>
            </div>
            <div class="flex-row">
              <input type="text" placeholder="Amount" name="amount" id="amount" />
            </div>
            <div class="flex-row">
              <select id="medRoute" name="route" required>
                <option selected="selected" value="Route">Route *</option>
                <option value="By mouth">By mouth</option>
                <option value="By mouth under tongue">By mouth under tongue</option>
                <option value="Cheek of mouth">Cheek of mouth</option>
                <option value="Each ear">Each ear</option>
                <option value="Each eye">Each eye</option>
                <option value="Inhalation">Inhalation</option>
              </select>
            </div>
            <div class="flex-row">
              <input required type="text" placeholder="Reason *" name="reason" id="medReason" v-model="diagSearchDescrip"
                @keyup.prevent="showDiagSearch" />
              <div v-if="searchedDiags && searchedDiags.length != 0" class="medDiagSearch">
                <div v-for="diag in searchedDiags" class="medIcdli" :key="diag.code" @click="clickDiag(diag)">
                  <span id="icdcode">{{ diag.code }}</span> -
                  <span id="icddesript">{{ diag.description }}</span>
                </div>
              </div>
            </div>
            <div class="flex-row">
              <input type="text" placeholder="Instruction" name="instructions" id="medInstructions" />
            </div>
          </div>
          <div class="medsecondSec col-sm-12 col-md-4 col-lg-4">
            <div class="flex-row medLabelGroup">
              <label class="medDateLabel">Start Date</label><label class="medDateLabel">End Date</label>
            </div>
            <div class="flex-row">
              <input type="date" id="medStartdate" name="startDate" />
              <input type="date" id="Medenddate" name="endDate" />
            </div>
            <div class="flex-row">
              <select id="neworchange" name="neworchange">
                <option selected="selected" value="Dose UOM">New/Change</option>
                <option value="New">New</option>
                <option value="Change">Change</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div class="flex-column">
              <input type="text" id="drugcategory" name="drug" placeholder="Drug Classification" />
            </div>
          </div>
          <div class="medthirdSec col-sm-12 col-md-4 col-lg-4">
            <div class="flex-column medThirdCol">
              <label>Medication Understanding</label>
              <label><input name="understanding" type="radio" id="meddirectionuse" />Direction for Use</label>
              <label><input name="understanding" type="radio" id="Medpurpose" />Purpose</label>
              <label><input type="radio" id="MedSideffects" name="understanding" />Side Effects/Interactions</label>
              <label><input name="understanding" type="radio" id="noUnder" />None</label>
            </div>
            <div class="flex-column medThirdCol">
              <label>Additional Settings</label>
              <label><input type="radio" id="agencyadmin" name="settings" />Agency
                Administered</label>
              <label><input type="radio" id="highrisk" name="settings" />High
                Risk</label>
              <label><input type="radio" id="noSettings" name="settings" />None</label>
            </div>
            <div class="flex-column medThirdBtn">
              <input type="submit" id="savemedbtn" value="Save" />
              <input type="button" id="cancelmedbtn" @click="closeMed" value="Cancel" />
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="columnrow">
      <!--Start Colum-->
      <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
        <span id="row" class="coltext">Order ID</span>
      </div>
      <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
        <span id="row" class="coltext">Medication</span>
      </div>
      <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
        <span id="row" class="coltext">Amount</span>
      </div>
      <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
        <span id="row" class="coltext">Diagnosis</span>
      </div>
      <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
        <span id="row" class="coltext">Frequency</span>
      </div>
      <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
        <span id="row" class="coltext">Start to End</span>
      </div>
      <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
        <span id="row" class="coltext">Route</span>
      </div>
      <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
        <span id="row" class="coltext">Writer</span>
      </div>
    </div>
    <!--end Column top-->
    <template v-if="allMeds">
      <div v-for="med in allMeds.slice().reverse()" :key="'med' + med.medentryid" class="columnrow">
        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
          <span id="row" class="coltext">{{ med.order_number }}</span>
        </div>
        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
          <span id="row" class="coltext">{{ med.medname }}</span>
        </div>
        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
          <span id="row" class="coltext">{{ med.med_amount }}</span>
        </div>
        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
          <span id="row" class="coltext">{{ med.diagnose_code }}</span>
        </div>
        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
          <span id="row" class="coltext">{{ med.med_frequency }}</span>
        </div>
        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
          <span id="row" class="coltext">{{ med.med_startdate ? med.med_startdate : '—' }} to {{ med.med_enddate ? med.med_enddate : '—' }}</span>
        </div>
        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
          <span id="row" class="coltext">{{ med.route }}</span>
        </div>
        <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
          <span id="row" class="coltext">{{ med.writer }}</span>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { CURR_API, OTHER_API } from "@/constants/apis";
import axios from "axios";
import { mapGetters } from "vuex";
import $ from "jquery";
import { medTimes } from '@/constants/med-times'
import {getDescByCcd} from "@/data/getters";

export default {
  name: "CurrentMed",
  data() {
    return {
      mT: null,
      diagSearchCode: "", // ICD-10 search code value
      diagSearchDescrip: "", // ICD-10 search description (textfield) value
      searchedDiags: [], // List of ICD codes retrieved via icdSearch

      medicationSearchCode: "", // Medication search code value
      medicationSearchDescrip: "", // Medication search description (textfield) value
      searchedMeds: [], // List of medications retrieved via medicationSearch
      allMeds: null, // List of medications already saved for patient

      manualAllergies: []
    };
  },
  async mounted() {
    this.loadMedications()
    this.getAllergies()
    this.mT = medTimes
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    patient: function () {
      return this.allData.patient;
    },
    allergies: function () {
      let groupings = this.allData.allergyGroupings
      let result = []
      if (groupings) {
        groupings.forEach(allergy => {
          result.push(getDescByCcd(allergy.codes[0],this.allData))
        });
      }
      return result
    }
  },
  methods: {
    getMedAdmin() {
      return {
        name: "MedAdminNavigation"
      }
    },
    async getAllergies(){
      let content = {
        "Allergy": {
          "API_Meth": "GetAllergies",
          "pid": this.allData.patient.externId
        }
      }
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          let result = res.data.allergies
          if (result) {
            result.forEach(aller => {
              this.manualAllergies.push(aller.name)
            });
          }
        });
    },
    async loadMedications() {
      let content = {
        MedGrid: {
          API_Meth: "PopulateMedGrid",
          pid: this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.gridhtml) {
            this.allMeds = res.data.data;
          } else {
            this.allMeds = null;
          }
        });
    },
    showAddMed() {
      $("#mediationmodal" + this.patient.id).css("display", "flex");
      $("form .modalbottom").css("display", "flex");
      $("#dosesform" + this.patient.id).css("display", "block");
    },
    clickMed(med) {
      this.medicationSearchCode = med.rxcui;
      this.medicationSearchDescrip = med.name;
      this.searchedMeds = [];
    },
    closeMed() {
      let doses = document.getElementById("dosesform" + this.patient.id);
      doses.reset();
      doses.style.display = "none";
      let form = document.getElementById("mediationmodal" + this.patient.id);
      form.style.display = "none";
      this.medicationSearchCode = "";
      this.medicationSearchDescrip = "";
      this.diagSearchCode = "";
      this.diagSearchDescrip = "";
    },
    async saveMed() {
      let form = document.getElementById("dosesform" + this.patient.id);
      let content = {
        MedicationInsert: {
          API_Meth: "InsertMedication",
          patientID: this.patient.externId,
          ordernumber: 0,
          medname: this.medicationSearchDescrip,
          doseamount: form.elements['amount'].value,
          doseUOM: "", //form.elements['UOM'].value,
          frequency: form.elements["freq"].value,
          diagcode: form.elements["reason"].value,
          medRoute: form.elements["route"].value,
          altroute: "",
          instruction: form.elements["instructions"].value,
          medstrtdt: form.elements["startDate"].value ? form.elements["startDate"].value : null,
          medenddt: form.elements["endDate"].value ? form.elements["endDate"].value : null,
          changetype: form.elements["neworchange"].value,
          durgclassification: form.elements["drug"].value,
          prn: document.getElementById("prncheckbox" + this.patient.id).checked,
          directionuse: form.elements["understanding"].value,
          additionalsettings: form.elements["settings"].value,
          status: "Active",
          writer: this.allData.manager.name
        },
      };
      console.log(content);
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.sqlresult && res.data.sqlresult == "Inserted") {
            this.medicationSearchCode = "";
            this.medicationSearchDescrip = "";
            this.diagSearchCode = "";
            this.diagSearchDescrip = "";
            this.loadMedications();
            alert("Medication successfully added");
            document.getElementById(
              "mediationmodal" + this.patient.id
            ).style.display = "none";
            $("#mediationmodal" + this.patient.id).css("display", "none");
            // $(".modalbottom form").css("display","none");
            // $(".mednamesec").css("display","none");
            form.reset();
          } else {
            alert(
              "Error with medication insertion. Try again or contact an administrator."
            );
          }
        });
    },
    async showMedSearch() {
      if (this.medicationSearchDescrip == "") {
        this.searchedMeds = [];
        return;
      }
      let posturl =
        "https://rxnav.nlm.nih.gov/REST/drugs.json?name=" +
        this.medicationSearchDescrip;
      await axios.get(posturl).then((res) => {
        if (res.data.drugGroup.conceptGroup) {
          for (let tty of res.data.drugGroup.conceptGroup) {
            if (tty.conceptProperties) {
              this.searchedMeds = this.searchedMeds.concat(
                tty.conceptProperties
              );
            }
          }
        } else {
          this.searchedMeds = [];
        }
      });
    },
    async showDiagSearch() {
      if (this.diagSearchDescrip == "") {
        this.searchedDiags = [];
        return;
      }
      if (true) {
        let content = {
          action: "Search",
          searchTerm: this.diagSearchDescrip,
          ICDCode: "",
          ICDReleaseUrl: "",
        };
        await axios
          .post(CURR_API + "/icd_calls.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            console.log(res);
            if (res.data.result == 0) {
              this.searchedDiags = [];
            } else {
              this.searchedDiags = res.data.actualResults;
            }
          });
      }
      // else {
      //   let content = {
      //     "action": "CodeLookUp",
      //     "searchTerm": "",
      //     "ICDCode":
      //   }
      // }
    },
    clickDiag(diag) {
      this.diagSearchCode = diag.code;
      this.diagSearchDescrip = diag.code + " - " + diag.description;
      this.searchedDiags = [];
    },
  },
};
</script>
<style scoped lang="scss">
.header2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  // color: #0060ff;
}

.title {
  margin-right: 20px;
}

.allergytext {
  color: red;
}
</style>
